import { getUnixTimestamp } from "../../utils";
import { IPetBirthdayUpdateRequest, IPetMedicalUpdateRequest, IPetUpdateRequest } from "./pet-update.interface";
import { PetBirthdayUpdateType, PetMedicalFormType, PetUpdateFormType } from "./pet-update.schema";

export const mapToPetUpdateRequest = (
  pet: PetUpdateFormType,
): IPetUpdateRequest => {
  let birthdateGMT0 = null;

  if (pet.birthdate) {
    birthdateGMT0 = getUnixTimestamp(pet.birthdate);
  } else {
    birthdateGMT0 = "";
  }

  return {
    name: pet.name?.replace(/\s+/g, " "),
    birthdate: `${birthdateGMT0}`,
    isDesexed: pet.isDesexed === "1" ? true : false,
    idColor: pet.idColor || null,
  };
};

export const mapToPetBirthdayUpdateRequest = (
  pet: PetBirthdayUpdateType,
): IPetBirthdayUpdateRequest => {
  let birthdateGMT0 = null;

  if (pet.birthdate) {
    birthdateGMT0 = getUnixTimestamp(pet.birthdate);
  } else {
    birthdateGMT0 = "";
  }

  return {
    birthdate: `${birthdateGMT0}`,
  };
};

export const mapToPetMedicalUpdateRequest = (
  pet: PetMedicalFormType,
): IPetMedicalUpdateRequest => {
  return {
    medicalRecord: {
      city: pet.medicalRecord.city,
      clinicName: pet.medicalRecord.clinicName,
    },
  };
};
